import { render, staticRenderFns } from "./confirmMessage.vue?vue&type=template&id=20204fe3&scoped=true&"
import script from "./confirmMessage.vue?vue&type=script&lang=js&"
export * from "./confirmMessage.vue?vue&type=script&lang=js&"
import style0 from "./confirmMessage.vue?vue&type=style&index=0&id=20204fe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20204fe3",
  null
  
)

export default component.exports